import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ReportingAccountSearchService } from '@http/clients/reporting-app/reporting-account-search.service';
import { GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { CustomMenuItemComponent } from '../../../custom-menu-item/custom-menu-item.component';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-account-form-editor',
    templateUrl: './report-account-form-editor.component.html',
    styleUrls: ['./report-account-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportAccountFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, CustomMenuItemComponent]
})
export class ReportAccountFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Accounts');
    placeholderText = input<string>('Search Accounts');

    private readonly accountSearchService = inject(ReportingAccountSearchService);

    async ngOnInit(): Promise<void> {
        const selectedIds = this.selectedValue();
        if (selectedIds?.length) {
            const selected = await this.accountSearchService.getByIds(selectedIds);
            this.selectedItems.set(selected);
        }
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text?.trim()) {
            this.items.set([]);
            return;
        }
        const accounts = await this.accountSearchService.search(text);
        this.items.set(accounts);
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(): any[] {
        return this.selectedItems() ?? [];
    }
}
